import {
	getRouters
} from '@/api/menu'
import {
	defaultRouterMap
} from '@/router/index'
import Layout from '@/views/main'
const state = {
	routes: [], //静态 路由 + 后台返回当前用户的的路由  合并
	addRoutes: [] //后台返回当前用户的的路由
}

const getters = {
	routes: state => state.routes,
	roles: state => state.roles,

}
const mutations = { //同步方法
	SET_ROUTES(state, value) {
		state.addRoutes = value
		state.routes = defaultRouterMap.concat(value) //拼接动态路由
	}
}
const actions = {
	// 生成路由
	GenerateRoutes({
		commit
	}) {
		return new Promise(resolve => {
			// 向后端请求路由数据
			getRouters().then(res => {
				const accessedRoutes = filterAsyncRouter(res.data.data)
				//* 通配符 匹配所有路径
				accessedRoutes.push({ path: '*', redirect: '/404', hidden: true })
				commit('SET_ROUTES', accessedRoutes)
				resolve(accessedRoutes)
			})
		})
	}

}
// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap) {
	return asyncRouterMap.filter(route => {
		if (route.component) {
			// Layout组件特殊处理
			if (route.component === 'Layout') {
				route.component = Layout
			} else {
				route.component = loadView(route.component)
			}
		}
		if (route.children != null && route.children && route.children.length) {
			route.children = filterAsyncRouter(route.children)
		}
		return true
	})
}
export const loadView = (view) => { // 路由懒加载
	return () => import(`@/views/${view}`)
}


export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
